import CreateEventContainer from "./MainContainer"

function CreateEventPage(){
    return(
        <CreateEventContainer />
    )
}

export default CreateEventPage